import React, { useEffect, useState } from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import I18N from "../../../../../../Wirtschaftswunder/oc-modules/oc-I18N/I18N";
import { InputBase } from "@material-ui/core";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Slider from "@mui/material/Slider";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import HeightIcon from "@mui/icons-material/Height";
import SearchIcon from "@mui/icons-material/Search";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import { TabsListUnstyled, TabsUnstyled, TabUnstyled, tabUnstyledClasses } from "@mui/base";
import styled from "@emotion/styled";
//
//
//
// NICHT MEHR AKTUELL, ZUSAMMENGEFÜHRT MIT INTERIORS.JSX
//
//
//
const TabsList = styled(TabsListUnstyled)`
  white-space: nowrap;
  overflow-x: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: space-between;
  padding-top: 12px;
  padding-bottom: 4px;
  margin-bottom: -8px;
  box-sizing: content-box;
`;

const Tab = styled(TabUnstyled)`
  background-color: #fff;
  color: #939599;
  padding: 6px 12px;
  outline: none;
  border-width: 0 0 2px 0;
  border-bottom-color: transparent;
  border-style: solid;
  box-shadow: none;
  font-size: 18px;

  &:first-of-type {
    margin-left: 100px;
  }

  &:last-of-type {
    margin-right: 50px;
  }

  &:hover {
    border-bottom-color: #C91113;
    color: #3A415A;
  }

  &.${tabUnstyledClasses.selected} {
    background-color: #fff;
    color: #3A415A;
    border-bottom-color: #C91113;
  }

  &:not(:last-of-type)::after {
    content: '';
    position: absolute;
    right: 0;
    top: 2px;
    bottom: 2px;
    width: 1px;
    height: 100%;
    background-color: #E5E5E5;
  }
`;

export default function Graphics(props) {
  const theme = useTheme();
  const [tab, setTab] = useState(window.innerWidth > 1200 ? false : 2);

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const handleWindowSizeChange = () => {
    setTab(window.innerWidth > 1200 ? false : 2);
  };

  const [possibleUploads, setPossibleUploads] = useState([]);
  const booth = props.booth;
  const letterArticle = APP.metadata.Artikel.find(a => a.Artikelnummer == "Letter");
  const state = APP.arrangement.state;
  const fontColors = booth?.ColorSetsForCompanyName?.length>0 ? booth?.ColorSetsForCompanyName[0].ColorSet.ColorForColorSet.map(c => '#'+c.Color.getHexString()) : [];
  const [currentColor, setCurrentColor] = useState(state.companyColor === '' ? booth?.ColorSetsForCompanyName?.length>0 ? '#'+booth?.ColorSetsForCompanyName[0].ColorSet?.ColorForColorSet.find(col => col.Default).Color.getHexString() : '' : state.companyColor);

  // Über Mesh/Material schauen welche verfügbar sind
  useEffect(() => {
    APP.arrangement.booth.jaco3d.posters.forEach( posterName => {
      if(APP.arrangement.booth.jaco3d[posterName].exists) setPossibleUploads(old => [...old, posterName]);
    });
    APP.arrangement.booth.jaco3d.logos.forEach( logoName => {
      if(APP.arrangement.booth.jaco3d[logoName].exists) setPossibleUploads(old => [...old, logoName]);
    });
    if (state.companyColor === '') state.companyColor = currentColor;
  }, [])

  const handleUpload = (file, poster) => {
    let code = APP.configuration.Code;
    const uploadFile = () => {
      APP.wkfgBackendApi.uploadContent(`Konfiguration/${code}`,
        [file])
        .then(([path]) => {
          handleFileChange(path, poster);
        });
    };
    if (code == null) {
      APP.save({
        quiet: true,
        noFotoSnapshots: true,
        skipURLUpdate: true,
        callback: (configuration) => {
          code = configuration.Code;
          uploadFile();
        },
      });
    } else {
      uploadFile();
    }
  };

  const handleFileChange = (path, poster) => {
    state[poster].url = path;
    APP.arrangement.booth?.jaco3d?.prepareCanvas(poster);
    APP.ui.dirty();
  }

  const handleSettingsChange = (poster, setting, value) => {
    state[poster][setting] = value;
    APP.arrangement.booth?.jaco3d?.updateCanvasTexture(poster);
    APP.ui.dirty();
  }

  const resetSize = (poster) => {
    state[poster].x = 50;
    state[poster].y = 50;
    state[poster].zoom = 50;
    APP.arrangement.booth?.jaco3d?.updateCanvasTexture(poster);
    APP.ui.dirty();
  }

  const changeText = (txt) => {
    APP.arrangement.changeCompName(txt);
    APP.arrangement.booth?.jaco3d?.updateTextCanvas();
  }

  const changeFontColor = (color) => {
    setCurrentColor(color);
    state.companyColor = color;
    APP.arrangement.booth?.jaco3d?.updateTextCanvas();
    APP.ui.dirty();
  }

  return (
    <Box sx={{overflow: "auto"}}>
      <Box sx={{
        borderBottom: "1px solid #E5E5E5",
        [theme.breakpoints.up("lg")]: {
          display: "none",
        }
      }}
      >
        <TabsUnstyled
          sx={{overflow: 'hidden'}}
          value={tab}
          onChange={(e, newValue) => setTab(newValue)}>
          <TabsList>
            {possibleUploads.map((string, index) => {
              {
                return <Tab value={2 + index}>{string}</Tab>;
              }
            })}
          </TabsList>
        </TabsUnstyled>
      </Box>

      <Box sx={{
        padding: "18px 18px 0 18px",
        display: 'none',
        [theme.breakpoints.up('lg')]: {
          display: 'block',
        }
      }}>
        <Typography variant="h6" sx={{
          color: '#3A415A',
          fontWeight: '700',
          paddingBottom: '8px',
          borderBottom: '1px solid #E2E2E2',
          marginBottom: 0,
        }}>
          {I18N("Graphics")}
        </Typography>
      </Box>

      {(!tab || tab === 1) &&
        <>
          {APP.arrangement.booth.jaco3d.companyName.exists && fontColors.length > 0 &&
            <Box sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              padding: "0 18px 0 18px",
              flex: "1 1 auto",
              overflowY: "auto",
              minHeight: "150px",
              marginBottom: "8px",
              [theme.breakpoints.up("lg")]: {
                overflowY: "visible",
                height: "auto",
                marginBottom: "28px",
                padding: "18px 18px 0 18px",
                minHeight: "220px",
                flex: 'none',
              },
            }}>
              <>
                <Typography variant="h6" sx={{
                  display: "none",
                  color: "#3A415A",
                  fontWeight: "700",
                  paddingBottom: "4px",
                  borderBottom: "1px solid #E2E2E2",
                  marginBottom: "10px",
                  [theme.breakpoints.up("lg")]: {
                    display: "block",
                  },
                }}>
                  {I18N("Company Name")}
                </Typography>
                <ImageList
                  sx={{
                    overflowY: "visible",
                    display: "flex",
                    flexDirection: "row",
                    gap: "12px !important",
                    marginBottom: "13px",
                    [theme.breakpoints.up("lg")]: {
                      display: "grid",
                      flexDirection: "unset",
                      gap: "17px !important",
                    },
                  }}
                  cols={fontColors.length} gap={5}>
                  {fontColors.map(c => {
                    return (
                      <ImageListItem
                        onClick={() => changeFontColor(c)}
                        key={c}
                        cols={1}
                        sx={{
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          borderRadius: "50%",
                          width: "100%",
                        }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "43px",
                            height: "43px",
                            backgroundColor: c,
                            borderRadius: "50%",
                            border: "2px solid transparent",
                            boxShadow: "inset 4px 2px 4px rgba(0, 0, 0, 0.1)",
                            padding: "2px",
                            borderColor: (theme) =>
                              state.companyColor === c ? theme.palette.primary.main : `rgb(240, 240, 240)`,
                            "&:hover": {
                              borderColor: (theme) => theme.palette.primary.main,
                              cursor: "pointer",
                            },
                            [theme.breakpoints.up("lg")]: {
                              width: "34px",
                              height: "34px",
                            },
                          }}
                        >
                          {state.companyColor === c &&
                            <IconButton
                              color="white"
                              sx={{
                                boxShadow: 0,
                              }}
                            >
                              <CheckIcon />
                            </IconButton>
                          }
                        </Box>
                      </ImageListItem>
                    );
                  })}
                </ImageList>

                <InputBase
                  style={{
                    color: "#3A415A",
                    fontSize: "18px",
                    padding: "7px",
                    border: "1px solid #DDDDDD",
                  }}
                  label={I18N("Company Name")}
                  placeholder={I18N("Company Name")}
                  value={state.companyName}
                  onChange={e => changeText(e.target.value)}
                />
                <Typography variant="subtitle1">{I18N("Additional letters")} {APP.formatter.format(letterArticle.Preis)}</Typography>
              </>
            </Box>
          }
        </>
      }

      {possibleUploads.map((string, index) => {
        return (
          <>
            {(!tab || tab === 2 + index) &&
            <Box 
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                padding: "0 18px 0 18px",
                flex: "1 1 auto",
                overflowY: {
                  xs:  "auto",
                  lg: 'visible',
                },
                minHeight: {
                  xs: "150px",
                  lg: '220px'
                },
                marginBottom: {
                  xs: 0,
                  lg: "28px",
                },
                [theme.breakpoints.up("lg")]: {
                  padding: "20px 18px 0 18px",
                  flex: 'none',
                }
              }}
            >
              <Typography variant="h6" sx={{
                display: {
                  xs: "none",
                  lg: 'block',
                },
                color: "#3A415A",
                fontWeight: "700",
                paddingBottom: "4px",
                borderBottom: "1px solid #E2E2E2",
                marginBottom: "10px",
              }}
              >
                {string}
              </Typography>
              {!state[string].url &&
              <>
                <Button
                  sx={{
                    width: "100%",
                    backgroundColor: '#3A415A',
                    border: '1px solid #3A415A',
                    color: '#fff',
                    marginBottom: '8px',
                    '&:hover': {
                      backgroundColor: 'rgba(58,65,90,0.8) !important',
                      border: '1px solid #3A415A !important',
                    }
                  }}
                  variant="contained"
                  component="label"
                  startIcon={<CloudUploadIcon />}
                >
                  {I18N("Upload")}
                  <input
                    accept="image/png, image/jpeg"
                    type="file"
                    id={string}
                    hidden
                    onChange={e => handleUpload(e.target.files[0], string)}
                  />
                </Button>
                <Typography variant="caption">{I18N("Image Upload Text")}</Typography>
              </>}
              {state[string].url &&
              <>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: '15px',
                }}>
                  <CompareArrowsIcon color={'secondary'} sx={{marginRight: '8px'}} />
                  <Slider
                    size="small"
                    defaultValue={50}
                    value={state[string].x}
                    onChange={e => handleSettingsChange(string, "x", e.target.value)}
                    aria-label="Small"
                    color="secondary"
                    valueLabelDisplay="auto"
                    sx={{
                      '.MuiSlider-thumb': {
                        width: '16px',
                        height: '16px',
                        "&:hover": {
                          backgroundColor: '#4C4C4C',
                        }
                      }
                    }}
                  />
                </Box>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: '15px',
                }}>
                  <HeightIcon color={'secondary'} sx={{marginRight: '8px'}} />
                  <Slider
                    size="small"
                    defaultValue={50}
                    value={state[string].y}
                    onChange={e => handleSettingsChange(string, "y", e.target.value)}
                    aria-label="Small"
                    color="secondary"
                    valueLabelDisplay="auto"
                    sx={{
                      '.MuiSlider-thumb': {
                        width: '16px',
                        height: '16px',
                        "&:hover": {
                          backgroundColor: '#4C4C4C',
                        }
                      }
                    }}
                  />
                </Box>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: '15px',
                }}>
                  <SearchIcon  color={'secondary'} sx={{marginRight: '8px'}} />
                  <Slider
                    size="small"
                    defaultValue={50}
                    value={state[string].zoom}
                    onChange={e => handleSettingsChange(string, "zoom", e.target.value)}
                    aria-label="Small"
                    color="secondary"
                    valueLabelDisplay="auto"
                    sx={{
                      '.MuiSlider-thumb': {
                        width: '16px',
                        height: '16px',
                        "&:hover": {
                          backgroundColor: '#4C4C4C',
                        }
                      }
                    }}
                  />
                  <AspectRatioIcon  color={'secondary'} sx={{marginLeft: '8px'}} onClick={() => resetSize(string)}/>
                </Box>
                <Button
                  sx={{
                    width: "100%",
                    backgroundColor: '#fff',
                    border: '1px solid #3A415A',
                    color: '#3A415A',
                    marginBottom: '20px',
                    '&:hover': {
                      color: '#fff',
                      border: '1px solid #3A415A !important',
                      backgroundColor: '#3A415A !important',
                    }
                  }}
                  variant="contained"
                  onClick={() => handleFileChange("", string)}>
                  {I18N("Remove Poster")}
                </Button>
              </>}
            </Box>
            }
          </>);
      })}
    </Box>
  );
}
